import React, { useState } from "react";
import SelectInput from "../common/SelectInput/SelectInput";
import { ReactComponent as DrpDwnIcon } from "./../../resources/images/icons/DrpDwnIcon.svg";
import DateSelector from "../common/DateSelector/DateSelector";

interface FilterProps {
  selectedOption: { value: string | number; label: string } | null | undefined;
  fromDate: Date | null;
  toDate: Date | null;
  handleChange: (    option: { value: string | number; label: string } | null) => void;
  handleFromDateChange: (date: Date | null) => void;
  handleToDateChange: (date: Date | null) => void;
  handleFilterSubmit: () => void;
  options?: { value: string | number; label: string }[] | [];
}

const Filter: React.FC<FilterProps> = ({
  selectedOption,
  fromDate,
  toDate,
  handleChange,
  handleFromDateChange,
  handleToDateChange,
  handleFilterSubmit,
  options,
}) => {
  return (
    <div className="mjp_section-wrapper m-t-16 filter_container">
      <div className="filter-heading">Filter by</div>

      <div className="date-filters">
        <div className="date-range-text">Date range</div>
        <div className="date-range-selectors">
          <div className="date-selector-wrapper m-r-10">
            <DateSelector
              selectedDate={fromDate}
              onDateChange={handleFromDateChange}
              placeholder="From"
              maxToday
            />
          </div>
          <div className="date-selector-wrapper">
            <DateSelector
              selectedDate={toDate}
              onDateChange={handleToDateChange}
              placeholder="To"
              maxToday
            />
          </div>
        </div>
      </div>

      <div className="job-type-filters">
        <div className="job-type-text">Job type</div>
        <div className="job-type-selector">
          <SelectInput
            value={selectedOption}
            onChange={handleChange}
            size="medium"
            options={options}
            placeholder="Select job type"
            dropDownIcon={<DrpDwnIcon />} // Custom up arrow icon
          />
        </div>
      </div>

      <div className="filter-btn">
        <button
          className="foundit-button secondaryButton medium"
          onClick={handleFilterSubmit}
          disabled={(selectedOption != null || fromDate != null || toDate != null) ? false : true}
        >
          Filter
        </button>
      </div>
    </div>
  );
};

export default Filter;
